import * as React from 'react';
import { connect } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

import CollapsibleTree from '../components/tree/CollapsibleTree';
import CurrentList from '../components/edit/CurrentList';
import Filter from '../components/filter/Filter';
import Intro from '../components/ui/Intro';
import Loading from '../components/ui/Loading';
import ListManager from './ListManager';
import {
	fetchTree,
	fetchLists,
	addRemoveItemAction,
	showBannerMessage,
	clearBannerMessage,
} from '../actions/actions';
import ieFrom from '../polyfills/from';
import { MESSAGE_TYPE_WARNING } from '../global-constants';
import './styles/App.scss';

export class AppClass extends React.Component {
	componentDidMount() {
		this.props.fetchTree();
		this.props.fetchLists();
	}

	addRemoveItem = (ids, isAdding = true) => {
		//polyfill for Array.from which Set seems to need
		ieFrom();
		const { selectedList: { id, distList }, toggleItem, allLists } = this.props;
		if (id.length > 0) {
			let list;
			if (isAdding) {
				list = [...new Set([ ...distList, ...ids ])];
			} else {
				list = distList.filter( x => ids.indexOf(x) === -1 )
			}

			toggleItem(id, list);
		}
	}

	checkForEmptyList = (ids, isAdding) => {
		// decide if we can perform this check operation
		const { selectedList: { distList } , i18n, setBanner, clearBanner } = this.props;

		// only care about deleting ones already on our list
		const matchingIds = ids.filter(x => distList.indexOf(x) > - 1);
		const isRemovingLastAcct = !isAdding && matchingIds.length >= distList.length;

		isRemovingLastAcct
			? setBanner(i18n.t('ERROR_LIST_IS_EMPTY'), MESSAGE_TYPE_WARNING, true)
			: clearBanner();
	}

	renderTree = (tree, selectedList, treeIsLoaded, isFiltering) => {
		let component = null;

		if (treeIsLoaded) {
			if (selectedList.id.length > 0) {
				// Display tree and filter
				component = (
					<React.Fragment>
						<Filter tree={tree} addRemoveItem={this.addRemoveItem} checkForEmptyList={this.checkForEmptyList} />
						{isFiltering ? null : <CollapsibleTree {...this.props} addRemoveItem={this.addRemoveItem} checkForEmptyList={this.checkForEmptyList} />}
					</React.Fragment>
				);
			} else {
				// Display initial instructions
				component = (<Intro />);
			}
		} else {
			// Display 'Loading...'
			component = (<Loading />);
		}

		return component;
	}

	render() {
		const { tree, selectedList, treeIsLoaded, isFiltering } = this.props;
		return (
			<Router>
				<div id='app_container'>
					<ListManager {...this.props} />
					<div id='work_area'>
						<CurrentList tree={tree} addRemoveItem={this.addRemoveItem} checkForEmptyList={this.checkForEmptyList}/>
						{this.renderTree(tree, selectedList, treeIsLoaded, isFiltering)}
					</div>
				</div>
			</Router>
		);
	}
}

AppClass.propTypes = {
	allLists: PropTypes.array.isRequired,
	fetchTree: PropTypes.func.isRequired,
	fetchLists: PropTypes.func.isRequired,
	i18n: PropTypes.shape({}).isRequired,
	toggleItem: PropTypes.func.isRequired,
	tree: PropTypes.shape({}).isRequired,
	treeIsLoaded: PropTypes.bool.isRequired,
	isFiltering: PropTypes.bool.isRequired,
	selectedList: PropTypes.shape({}).isRequired,
	setBanner: PropTypes.func.isRequired,
	clearBanner: PropTypes.func.isRequired,
};

const mapDispatchToProps = dispatch => ({
	fetchTree: () => {
		dispatch(fetchTree());
	},
	fetchLists: () => {
		dispatch(fetchLists());
	},
	toggleItem: (selectedList, list) => {
		dispatch(addRemoveItemAction(selectedList, { distList: list }))
	},
	setBanner: (message, messageType, autoDismiss) => {
		dispatch(showBannerMessage(message, messageType, autoDismiss))
	},
	clearBanner: () => {
		dispatch(clearBannerMessage());
	},
});

const mapStateToProps = (state) => ({
	allLists: state.allLists || [],
	selectedList: state.selectedList,
	tree: state.tree,
	treeIsLoaded: state.treeIsLoaded,
	isFiltering: state.isFiltering,
});

const App = connect(
	mapStateToProps,
	mapDispatchToProps
)(AppClass);

export default withTranslation()(App);
